<template>
  <div v-if="item.type == 'link'">
    <vs-dropdown v-if="!preview" vs-custom-content vs-trigger-click>
      <vs-button
        v-if="!preview"
        style="cursor: pointer;"
        radius
        color="danger"
        type="flat"
        icon-pack="feather"
        icon="icon-trash"
      ></vs-button>
      <vs-dropdown-menu class="dropdown-login">
        <div class="dropdownMenu">
          <div class="d-flex" style="justify-content:space-between">
            <h3 class="mb-3">Supprimer ?</h3>
          </div>
          <vs-button
            style="width:100% !important;"
            @click="remove()"
            color="danger"
            type="filled"
            icon-pack="feather"
            icon="icon-check"
            size="flat"
          ></vs-button>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
    <a :contenteditable="contenteditable" :href="link" class="pb-link">
      {{ item.content }}
    </a>
    <input
      v-if="editLink"
      type="text"
      v-model="link"
      @blur="save"
      class="edit"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["preview", "contenteditable", "item", "itemIndex"],
  data() {
    return {
      editLink: false,
      link: "",
    };
  },
};
</script>

<style scoped>
.preview {
  position: absolute;
  right: 4px;
  bottom: 4px;
}

.edit {
  float: right;
  width: 90%;
}

a {
  color: black;
}
</style>
